import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { map } from 'rxjs';
import { SubscriptionProduct } from '../models';

export interface CheckoutItem {
  price: string;
  quantity: number;
}

export type CreateCheckoutUrlParams = {
  line_items: CheckoutItem[];
};

export interface CreateCheckoutUrlResponse {
  checkout_url: string;
}

export const PAYMENTS_API_URL = `${environment.apps.kanga}/api/v1/payments/`;

@Injectable({ providedIn: 'root' })
export class PaymentsApiService {
  constructor(private httpClient: HttpClient) {}

  getProducts() {
    return this.httpClient.get<SubscriptionProduct[]>(
      `${PAYMENTS_API_URL}products/`
    );
  }

  createCheckoutUrl(params: CreateCheckoutUrlParams) {
    return this.httpClient
      .post<CreateCheckoutUrlResponse>(`${PAYMENTS_API_URL}checkout/`, params)
      .pipe(map((response) => response.checkout_url));
  }

  getCheckoutSession(sessionId: string) {
    return this.httpClient.get<{
      status: 'complete' | 'open' | 'expired';
      license_code: string;
      license_name: string;
    }>(`${PAYMENTS_API_URL}checkout/${sessionId}/`);
  }
}
